import { useEffect, useState } from 'react';
import { Modal, Input, Alert, Space } from 'antd';

interface Props {
  open: boolean;
  /** 弹窗标题，如「发送 BOM 通知邮件」 */
  title?: string;
  loading?: boolean;
  onCancel: () => void;
  /** 发送：主题/正文留空则传 undefined（后端用默认内容） */
  onSend: (subject?: string, body?: string) => void;
}

/** 发送/补发通知邮件：可选自定义主题与正文，留空用系统默认 */
export function SendMailModal({ open, title = '发送通知邮件', loading, onCancel, onSend }: Props) {
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');

  useEffect(() => {
    if (open) {
      setSubject('');
      setBody('');
    }
  }, [open]);

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      okText="发送"
      confirmLoading={loading ?? false}
      cancelText="取消"
      onOk={() => onSend(subject.trim() || undefined, body.trim() || undefined)}
      destroyOnClose
    >
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        <Alert
          type="info"
          showIcon
          message="主题与正文均可留空，留空则使用系统默认内容；邮件会附带原文件发给通知联系人。"
        />
        <Input
          placeholder="邮件主题（留空用默认）"
          value={subject}
          maxLength={200}
          onChange={(e) => setSubject(e.target.value)}
        />
        <Input.TextArea
          placeholder="邮件正文（留空用默认）"
          value={body}
          rows={5}
          maxLength={5000}
          onChange={(e) => setBody(e.target.value)}
        />
      </Space>
    </Modal>
  );
}
